import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import KeyIcon from '@mui/icons-material/Key'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import PersonIcon from '@mui/icons-material/Person'
import PolicyIcon from '@mui/icons-material/Policy'
import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography
} from '@mui/material'
import { FC, ReactElement, useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import DviPage from '../../components/DviPage/DviPage'
import { ClickableCard } from '../../components/SharedUI/ClickableCard'
import { AppRoutes } from '../../models'
import { AuthContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { getNameInitials } from '../../utils/getNameInitials/getNameInitials'
const DviProfile: FC = () => {
  const { currentUser } = useContext(AuthContext)
  const { shopProfile } = useContext(AppContext)
  const { logOut } = useContext(AuthContext)

  const navigate = useNavigate()
  const listItem = (
    title: string,
    info: string,
    icon: ReactElement,
    isPhoneLink?: boolean
  ) => {
    return (
      <ListItem>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText
          primary={
            <>
              <Typography variant="subtitle1" component="span">
                {title}{' '}
              </Typography>
              {isPhoneLink ? (
                <a href={`tel:${info}`}>{info}</a>
              ) : (
                <Typography component="span">{info}</Typography>
              )}
            </>
          }
        />
      </ListItem>
    )
  }
  return (
    <DviPage title="Settings">
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent={'space-between'}
        sx={{ height: '100%' }}>
        <Box sx={{ flexGrow: 1, flexShrink: 1 }}></Box>
        {currentUser?.profilePicThumbnailUrl ? (
          <Avatar
            alt={currentUser!.name}
            src={currentUser!.profilePicThumbnailUrl!}>
            {getNameInitials(currentUser.name || '')}
          </Avatar>
        ) : currentUser?.name ? (
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            {getNameInitials(currentUser.name)}
          </Avatar>
        ) : (
          <></>
        )}
        <Typography variant="h6">{currentUser?.name}</Typography>
        <Typography variant="body2">
          {currentUser?.roles.map((role) => role.roleName!).join(' , ')}
        </Typography>
        <Box sx={{ flexGrow: 1, flexShrink: 1 }}></Box>
        <Paper sx={{ width: '100%' }}>
          <Stack p={2} spacing={2}>
            <ClickableCard>
              <List dense>
                {listItem(
                  'Shop:',
                  shopProfile?.info!.name || '',
                  <DirectionsCarIcon />
                )}
                {listItem(
                  'Phone Number:',
                  shopProfile?.info!.phone || '',
                  <LocalPhoneIcon />,
                  true
                )}
              </List>
            </ClickableCard>
            <ClickableCard
              onClick={() => navigate(AppRoutes.DVI_PASSWORD_RESET)}>
              <List dense>
                {listItem('Username:', currentUser?.name || '', <PersonIcon />)}
                {listItem('Password:', '******', <KeyIcon />)}
              </List>
            </ClickableCard>
            <ClickableCard
              onClick={() =>
                window.open('https://www.intuneauto.com/s/privacy_policy.pdf')
              }>
              <List dense>
                {listItem('Privacy Policy', '', <PolicyIcon />)}
              </List>
            </ClickableCard>
            <Box sx={{ textAlign: 'center' }}>
              <Button
                sx={{ mr: 2 }}
                onClick={() => navigate(AppRoutes.WORK_IN_PROGRESS)}
                variant="outlined">
                Go to Main App
              </Button>
              <Button onClick={logOut} variant="contained">
                Sign Out
              </Button>
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </DviPage>
  )
}

export default DviProfile
